/*
 *
 * DrawersPanel
 *
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useInjectReducer } from 'utils/injectReducer';
import { createStructuredSelector } from 'reselect';
import { makeSelectIsVisibleDrawersCompositionPanel } from './selectors';
import reducer from './reducer';
import { RootState } from './types';
import Panel from 'components/Panel';
import { displayDrawersCompositionPanelAction } from 'containers/DrawersCompositionPanel/actions';
import DrawerCompositionPanelContent from 'containers/DrawersCompositionPanel/DrawerCompositionPanelContent';

interface StateProps {
  isVisible: boolean;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  isVisible: makeSelectIsVisibleDrawersCompositionPanel(),
});

function DrawersCompositionPanel() {
  useInjectReducer({ key: 'drawersCompositionPanel', reducer: reducer });
  const dispatch = useDispatch();
  const { isVisible } = useSelector(stateSelector);

  const hidePanel = () => {
    dispatch(displayDrawersCompositionPanelAction(false));
  };

  return (
    <Panel close={hidePanel} isVisible={isVisible} autoclose>
      <DrawerCompositionPanelContent />
    </Panel>
  );
}

export default DrawersCompositionPanel;
